import React from 'react';

import { Course } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';

import { Metadata, MuiCardBaseProps, MuiCardCommonProps } from '../MuiCardBase/MuiCardBase';
import CourseMuiLongCard from './CourseMuiLongCard';
import CourseMuiShortCard from './CourseMuiShortCard';
import useScreenSize from '../../../../utils/useScreenSize';
import { useTranslation } from 'react-i18next';
import Tooltip from '../../../Tooltip';
import { palette } from '../../../../assets/styles/themes/tokens';

export interface CourseMuiCardProps extends MuiCardCommonProps {
  contentType: 'course';
  course: Course;
}

const CourseMuiCard: React.FC<CourseMuiCardProps> = (props) => {
  const { isSmallScreen } = useScreenSize();
  const component = isSmallScreen ? CourseMuiShortCard : CourseMuiLongCard;

  return React.createElement(component, props);
};

export const ThemeMetadata = ({ theme }: { theme: NonNullable<Course['theme']> }) => {
  const themes = theme.join(', ');
  return (
    <Tooltip label={themes} placement='top'>
      <Metadata icon='tag' label={themes} sx={{ color: palette.text.secondary }} />
    </Tooltip>
  );
};

export const PublisherMetadata = ({
  publisher,
}: {
  publisher: NonNullable<MuiCardBaseProps['publisher']>;
}) => {
  const { t } = useTranslation();
  return (
    <Tooltip label={publisher} placement='top'>
      <Metadata 
        icon='heart'
        sx={{ color: palette.text.secondary }}
        label={`${t('In cooperation with')}: ${publisher}`}
      />
    </Tooltip>
  );
};

export default CourseMuiCard;
